"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractProps = void 0;
var lodash_1 = require("lodash");
var extractProps = function (obj) { return function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    return lodash_1.flow([
        lodash_1.partialRight(lodash_1.map, function (prop) { return lodash_1.get(obj, prop); }),
        lodash_1.partialRight(lodash_1.filter, function (val) { return val !== undefined; }),
        function (val) { return val.length === 1 ? val[0] : val; }
    ])(props);
}; };
exports.extractProps = extractProps;
//# sourceMappingURL=extractProps.js.map